/* PDP KLOKI Star 2026: výběr N dárků (nabídka „vyber“, snippet ps26-darky). Převzato z
   _pdp-star-navrh/js/darky.js (varianta b8/b10). Texty z window.ps26D (snippet ps26-darky),
   částky v nejmenších jednotkách měny (data-cena), formát přes Intl podle jazyka a měny stránky.
   Fail-open: předvybrané dárky jsou zaškrtnuté už v HTML. */
(function () {
  var D = window.ps26D || {};
  var fmt = function (centy) {
    var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
    var n = centy / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'cs', { style: 'currency', currency: c, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return String(n) + ' ' + c; }
  };
  document.querySelectorAll('[data-dk-pick]').forEach(function (box) {
    var max = +box.getAttribute('data-dk-max') || 2;
    var zaklad = +box.getAttribute('data-dk-zaklad') || 0;
    var inputs = [].slice.call(box.querySelectorAll('input[type=checkbox]'));
    var stav = box.querySelector('[data-dk-stav]');
    var poradi = inputs.filter(function (i) { return i.checked; });

    function prepis(zprava) {
      var vyb = inputs.filter(function (i) { return i.checked; });
      var suma = vyb.reduce(function (s, i) { return s + (+i.getAttribute('data-cena') || 0); }, 0);
      var chybi = max - vyb.length;
      if (!stav) return;
      stav.innerHTML = chybi > 0
        ? (chybi === 1 ? (D.zbyva_1 || '') : (D.zbyva_n || '').replace('@N@', chybi))
        : (D.hodnota || '').replace('@CASTKA@', fmt(zaklad + suma)) + ' ' + (zprava || D.vymenite || '');
    }
    inputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        var zprava = '';
        poradi = poradi.filter(function (i) { return i !== inp; });
        if (inp.checked) {
          poradi.push(inp);
          if (poradi.length > max) {
            var ven = poradi.shift();
            ven.checked = false;
            zprava = (D.vymeneno || '').replace('@Z@', ven.getAttribute('data-nazev')).replace('@NA@', inp.getAttribute('data-nazev'));
          }
          var l = inp.closest('label');
          if (l) { l.classList.remove('is-novy'); void l.offsetWidth; l.classList.add('is-novy'); }
        }
        prepis(zprava);
      });
    });
    prepis('');
  });
})();

/* Výběr barvy dárku: štítek Barvy otevře malou nabídku, volba vymění fotku a dárek rovnou vybere */
(function () {
  var otevrene = null;
  function zavri(vratFokus) {
    if (!otevrene) return;
    var o = otevrene;
    otevrene = null;
    o.panel.hidden = true;
    o.btn.setAttribute('aria-expanded', 'false');
    if (vratFokus) o.btn.focus();
  }
  document.querySelectorAll('.dkv').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var host = btn.closest('[data-dkv-host]');
    if (!panel || !host) return;
    var foto = host.querySelector('.dkv-foto');
    var vstup = host.querySelector('input[type=checkbox]');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (otevrene && otevrene.btn === btn) { zavri(true); return; }
      zavri(false);
      panel.hidden = false;
      var obal = panel.offsetParent.getBoundingClientRect();
      var f = foto.getBoundingClientRect();
      var stred = f.left + f.width / 2 - obal.left;
      var sirka = panel.offsetWidth;
      var vlevo = Math.max(0, Math.min(stred - sirka / 2, obal.width - sirka));
      panel.style.left = vlevo + 'px';
      panel.style.top = (f.bottom - obal.top + 9) + 'px';
      panel.style.setProperty('--dkv-sipka', (stred - vlevo) + 'px');
      btn.setAttribute('aria-expanded', 'true');
      otevrene = { btn: btn, panel: panel };
      (panel.querySelector('[aria-pressed="true"]') || panel.querySelector('button')).focus();
    });
    panel.addEventListener('click', function (e) {
      e.stopPropagation();
      var o = e.target.closest('.dkv-o');
      if (!o) return;
      panel.querySelectorAll('.dkv-o').forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
      foto.src = o.getAttribute('data-foto');
      if (o.getAttribute('data-variant-id')) {
        (vstup || host).setAttribute('data-variant-id', o.getAttribute('data-variant-id'));
      }
      if (vstup) {
        vstup.setAttribute('data-varianta', o.getAttribute('data-varianta'));
        vstup.setAttribute('data-img', o.getAttribute('data-foto'));
        if (!vstup.checked) {
          vstup.checked = true;
          vstup.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      zavri(true);
    });
  });
  document.addEventListener('click', function () { zavri(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zavri(true); });
})();
